export default {
  apiBaseUrl: 'https://radio.mp3islam.com',
}
